import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { OuiButton } from 'omnium-ui/button';
import { OuiDialogModule } from 'omnium-ui/dialog';
import { QpiIconBoxComponent } from '../qpi-icon-box/qpi-icon-box.component';

export interface QpiSelectionAutoUpdateDialogData {
  /** Libellés des produits nouvellement sélectionnés automatiquement d'après le recueil */
  produitsAjoutes: string[];
  /** Le questionnaire Connaissance et expérience est complet après la mise à jour */
  isComplete: boolean;
}

/**
 * Prévient le consultant que des produits du recueil ont été sélectionnés automatiquement dans le questionnaire
 * Connaissance et expérience (textes provisoires en attendant la maquette).
 * Se ferme avec `true` si le consultant choisit de compléter le questionnaire.
 */
@Component({
  selector: 'app-qpi-selection-auto-update-dialog',
  imports: [OuiDialogModule, OuiButton, QpiIconBoxComponent],
  templateUrl: './qpi-selection-auto-update-dialog.component.html',
  styleUrl: './qpi-selection-auto-update-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QpiSelectionAutoUpdateDialogComponent {
  readonly data: QpiSelectionAutoUpdateDialogData = inject(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<MatDialogRef<QpiSelectionAutoUpdateDialogComponent, boolean>>(MatDialogRef);

  completerQuestionnaire(): void {
    this.dialogRef.close(true);
  }
}
